import $ from "jquery";

const foldableChangePassword = () => {
  const init = () => {
    const triggerButton = $('legend.fold-trigger');

    if (triggerButton.length > 0) {
      action(triggerButton);
    }
  };

  const action = (triggerButton) => {
    triggerButton.click(function() {
      $(this).next('fieldset').slideToggle('slow');
    });

    // Hide the fieldset initially
    triggerButton.next('fieldset').hide();
  };

  init();
};

try {
  foldableChangePassword();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
